import React from "react";
import loadable from "@loadable/component";
import Spinner from "theme/components/atoms/Spinner";

export default loadable(() => import("./Map"), {
  resolveComponent: (component) => component.default,
  fallback: <Spinner />,
  ssr: false,
});

const Marker = loadable(() => import("./Map"), {
  resolveComponent: (component) => component.Marker,
  fallback: <Spinner />,
  ssr: false,
});

export { Marker };
